import { connect } from "react-redux";
import Mrf from "./mrf";
import { bindActionCreators } from "redux";
import {
  fetchCategoryList,
    fetchCategoryType,
    fetchSubCategoryType,
    fetchCategory,
    
  } from "services/redux/maintenance/pmList/action";

// import {createMrfForMaintenance} from "services/redux/maintenance/pmList/action"; 

const mapStateToProps = (state) => ({
    
    typeData: state.pmListReducer.typeData,
    subCategoryType: state.pmListReducer.subCategoryType,
    categoryType: state.pmListReducer.categoryType,
    typeCategoryList: state.pmListReducer.typeCategoryList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchCategoryList,
        fetchCategoryType,
        fetchSubCategoryType,
        fetchCategory,
        // createMrfForMaintenance
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Mrf);
